import { Component, Input, OnInit, inject } from '@angular/core';
import { IArchiveOrder } from '../../../../../../models/order.models';
import { Router } from '@angular/router';
import { environment } from '../../../../../../../environments/environment';
import { CatalogFacade } from '../../../../../../facades/catalog.facade';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { ConfigurationFacade } from '../../../../../../facades/configuration.facade';
import { TranslateService } from '@ngx-translate/core';
import { AppUtils } from '../../../../../../utils/app.utils';
import { CustomerFacade } from '../../../../../../facades/customer.facade';

@Component({
  selector: 'app-spare-part-hybris-item-details',
  templateUrl: './spare-part-hybris-item-details.component.html',
  styleUrls: ['./spare-part-hybris-item-details.component.scss'],
  standalone: false,
})
export class SparePartHybrisItemDetailsComponent implements OnInit {
  private router: Router = inject(Router);
  private catalogFacade: CatalogFacade = inject(CatalogFacade);
  private configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);
  private translate: TranslateService = inject(TranslateService);
  private customerFacade: CustomerFacade = inject(CustomerFacade);

  @Input() orderDetails!: IArchiveOrder;
  @Input() isOpen: boolean = false;

  teamplayFleetDataLoading: boolean = false;
  isBusinessPartner$: Observable<boolean> = new Observable<boolean>();

  addresses: any[] = [
    {
      type: 'shipTo',
      translationKey: 'ship-to-address',
    },
    {
      type: 'soldTo',
      translationKey: 'sold-to-address',
    },
    {
      type: 'billTo',
      translationKey: 'bill-to-address',
    },
  ];

  private unsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.isBusinessPartner$ = this.customerFacade.isBusinessPartner();
  }

  redirectToOrderDetails(orderId: string): void {
    this.router.navigate([`/hybris-order-details/${orderId}`]);
  }

  formatIfMissingValue(attributeValue: string | undefined | null): string {
    return !attributeValue || attributeValue === 'empty' ? '' : attributeValue;
  }

  openInTeamplayFleet(): void {
    this.teamplayFleetDataLoading = true;
    this.catalogFacade.getShsEquipmentInstallBaseSystem(this.orderDetails.attributes.equipment).pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe({
      next: (installBaseSystem) => {
        const url: string = environment.teamplayFleetUrl + '/equipmentDetails.html' +
          '?materialNo=' + installBaseSystem.data[0].attributes.materialNumber +
          '&serialNo=' + installBaseSystem.data[0].attributes.serialNumber +
          '&country=' + AppUtils.getCurrentStore().storeId +
          '&tab=info' +
          '&search=' + installBaseSystem.data[0].attributes.contractNumber;
        window.open(url, '_blank');
        this.teamplayFleetDataLoading = false;
      },
      error: err => {
        if (err === 404) {
          this.configurationFacade.setAlert({
            message: this.translate.instant('spare-part-item-details.select-teamplay-fleet-error'),
            type: 'error',
          });
        }
        this.teamplayFleetDataLoading = false;
      },
    });
  }
}
